import { useFeatureFlags } from '../../feature-flags/FeatureFlagsProvider'
import { createFlagsHook } from '../createFlagsHook/createFlagsHook'

const useDocumentReviewLdFlags = createFlagsHook<typeof import('./documentReviewFlags.json')>()

/**
 * Whether to show document review on the surfaces the artefacts agent needs: the playbook settings it
 * reviews against, and the review of documents already attached to a request. The TPRM term matches the
 * agent's own gate, so where the agent cannot run its release flag carries nothing with it.
 *
 * The intake form reads `SHOW_DOCUMENT_REVIEW` directly instead. That flag switches a file-upload
 * question between extraction and playbook review, and releasing the agent must not change how an
 * organisation's request forms behave.
 */
export const useShowDocumentReview = (): boolean => {
  const { TPRM } = useFeatureFlags()
  const { SHOW_DOCUMENT_REVIEW, RELEASE_ARTEFACTS_AGENT } = useDocumentReviewLdFlags()

  return SHOW_DOCUMENT_REVIEW || (TPRM && RELEASE_ARTEFACTS_AGENT)
}
